var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Admin',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',[_c('downloaded-table')],1)],1),_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',[_c('pagination',{attrs:{"collection-name":"docsDownloadedByCompany"}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }